const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export default removeFromLocalStorage;
